import script from "./ToothQuantityCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ToothQuantityCard.vue?vue&type=script&setup=true&lang=js"

import "./ToothQuantityCard.vue?vue&type=style&index=0&id=026122f2&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-026122f2"]])

export default __exports__